import { createFileRoute, redirect } from '@tanstack/react-router';

/** Compat: URL antiga → /admin/unidades */
export const Route = createFileRoute('/_authenticated/unidades/')({
  beforeLoad: () => redirect({ to: '/admin/unidades' }),
});
